import * as React from "react";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import { useResource, Resources } from "Translations/Resources";
import { NoRecentActivities } from "Components/Dashboard/RecentActivities/NoRecentActivities";

type Props = {};

const StyledWrapper = styled.div`
  padding: ${props => props.theme.spacing(3, 2.8)};
`;

const StyledTitle = styled(Typography)`
  font-size: 16px;
  font-weight: 300;
  padding-bottom: ${props => props.theme.spacing(4)}px;
`;

export const RecentActivities: React.FunctionComponent<Props> = props => {
  const { t } = useResource();
  return (
    <StyledWrapper>
      <StyledTitle>{t(Resources.Dashboard.RecentActivities.Title)}</StyledTitle>

      <NoRecentActivities />
    </StyledWrapper>
  );
};
